import { default as _91slug_935LP6stTEdPMeta } from "/codebuild/output/src2543735077/src/nuxt-srovnejto/pages/nepodcento/[slug].vue?macro=true";
import { default as index9yG0gdku8pMeta } from "/codebuild/output/src2543735077/src/nuxt-srovnejto/pages/nepodcento/index.vue?macro=true";
import { default as _91slug_93NWyoSjUl8zMeta } from "/codebuild/output/src2543735077/src/nuxt-srovnejto/pages/volne-pozice/[slug].vue?macro=true";
import { default as pageoURvjj3AvnMeta } from "/codebuild/output/src2543735077/src/nuxt-srovnejto/.srovnejto/storyblok/pages/storyblok/page?macro=true";
import { default as headers_45testvokeNXNeVqMeta } from "/codebuild/output/src2543735077/src/nuxt-srovnejto/.srovnejto/storyblok/pages/storyblok/headers-test?macro=true";
import { default as homepage4eOMn8H449Meta } from "/codebuild/output/src2543735077/src/nuxt-srovnejto/.srovnejto/storyblok/pages/blog/homepage?macro=true";
import { default as articlezXVKd5dO8EMeta } from "/codebuild/output/src2543735077/src/nuxt-srovnejto/.srovnejto/storyblok/pages/blog/article?macro=true";
import { default as document_45patternsFCqj4Xa3v5Meta } from "/codebuild/output/src2543735077/src/nuxt-srovnejto/.srovnejto/storyblok/pages/blog/document-patterns?macro=true";
import { default as tag98NGVbty66Meta } from "/codebuild/output/src2543735077/src/nuxt-srovnejto/.srovnejto/storyblok/pages/blog/tag?macro=true";
import { default as autorOzgQE1bzMKMeta } from "/codebuild/output/src2543735077/src/nuxt-srovnejto/.srovnejto/storyblok/pages/blog/autor?macro=true";
import { default as categoryyTdaG31isMMeta } from "/codebuild/output/src2543735077/src/nuxt-srovnejto/.srovnejto/storyblok/pages/blog/category?macro=true";
import { default as sectionMJPP5NBDrBMeta } from "/codebuild/output/src2543735077/src/nuxt-srovnejto/.srovnejto/storyblok/pages/blog/section?macro=true";
import { default as all_45articles76OGgVzMztMeta } from "/codebuild/output/src2543735077/src/nuxt-srovnejto/.srovnejto/storyblok/pages/blog/all-articles?macro=true";
import { default as categoryvtbFvDmYZtMeta } from "/codebuild/output/src2543735077/src/nuxt-srovnejto/.srovnejto/storyblok/pages/glossary-of-terms/category?macro=true";
import { default as articleJSpzodw6xfMeta } from "/codebuild/output/src2543735077/src/nuxt-srovnejto/.srovnejto/storyblok/pages/glossary-of-terms/article?macro=true";
import { default as sectionV7IWqIZxQyMeta } from "/codebuild/output/src2543735077/src/nuxt-srovnejto/.srovnejto/storyblok/pages/adviser/section?macro=true";
import { default as complaintqZp9aBiZZwMeta } from "/codebuild/output/src2543735077/src/nuxt-srovnejto/.srovnejto/storyblok/pages/forms/complaint?macro=true";
import { default as price_45guarantee2oWX8rgzBWMeta } from "/codebuild/output/src2543735077/src/nuxt-srovnejto/.srovnejto/storyblok/pages/forms/price-guarantee?macro=true";
import { default as contactfogqljlmgvMeta } from "/codebuild/output/src2543735077/src/nuxt-srovnejto/.srovnejto/storyblok/pages/forms/contact?macro=true";
import { default as car_45insurance_45terminationmWt6lXuZIKMeta } from "/codebuild/output/src2543735077/src/nuxt-srovnejto/.srovnejto/storyblok/pages/forms/car-insurance-termination?macro=true";
import { default as mediaMZJwRAW6tUMeta } from "/codebuild/output/src2543735077/src/nuxt-srovnejto/.srovnejto/storyblok/pages/press/media?macro=true";
import { default as pressZm39Q9glDBMeta } from "/codebuild/output/src2543735077/src/nuxt-srovnejto/.srovnejto/storyblok/pages/press/press?macro=true";
import { default as slugVNu5yjJh0BMeta } from "/codebuild/output/src2543735077/src/nuxt-srovnejto/.srovnejto/storyblok/pages/press/slug?macro=true";
import { default as zadostgsAJfsnOuAMeta } from "/codebuild/output/src2543735077/src/nuxt-srovnejto/.srovnejto/loans/pages/loans/uniform/zadost?macro=true";
import { default as thankILCoC9jpGWMeta } from "/codebuild/output/src2543735077/src/nuxt-srovnejto/.srovnejto/loans/pages/loans/uniform/thank?macro=true";
import { default as srovnaniV4lUYULsxBMeta } from "/codebuild/output/src2543735077/src/nuxt-srovnejto/.srovnejto/loans/pages/loans/pujcka-na-miru/srovnani?macro=true";
import { default as calculationyqpkwxj0UoMeta } from "/codebuild/output/src2543735077/src/nuxt-srovnejto/.srovnejto/telco/pages/internet/calculation?macro=true";
import { default as thank_45you4aN2CnqAatMeta } from "/codebuild/output/src2543735077/src/nuxt-srovnejto/.srovnejto/telco/pages/internet/thank-you?macro=true";
import { default as detailWYAjS541OmMeta } from "/codebuild/output/src2543735077/src/nuxt-srovnejto/.srovnejto/telco/pages/internet/detail?macro=true";
import { default as inquiry9988CGsgIDMeta } from "/codebuild/output/src2543735077/src/nuxt-srovnejto/.srovnejto/telco/pages/internet/inquiry?macro=true";
import { default as offer_45listZD769t2j70Meta } from "/codebuild/output/src2543735077/src/nuxt-srovnejto/.srovnejto/telco/pages/internet/offer-list?macro=true";
import { default as calculationwt5eV9dsJTMeta } from "/codebuild/output/src2543735077/src/nuxt-srovnejto/.srovnejto/telco/pages/mobile/calculation?macro=true";
import { default as thank_45youqslCMtMBVhMeta } from "/codebuild/output/src2543735077/src/nuxt-srovnejto/.srovnejto/telco/pages/mobile/thank-you?macro=true";
import { default as inquiry8Hsy8u6AvBMeta } from "/codebuild/output/src2543735077/src/nuxt-srovnejto/.srovnejto/telco/pages/mobile/inquiry?macro=true";
import { default as offer_45listAOX6BHMCEvMeta } from "/codebuild/output/src2543735077/src/nuxt-srovnejto/.srovnejto/telco/pages/mobile/offer-list?macro=true";
import { default as detailmWcgGuLqJnMeta } from "/codebuild/output/src2543735077/src/nuxt-srovnejto/.srovnejto/telco/pages/mobile/detail?macro=true";
import { default as offerfx7r4Xu8cxMeta } from "/codebuild/output/src2543735077/src/nuxt-srovnejto/.srovnejto/telco/pages/packages/offer?macro=true";
import { default as inquiryFFip9VqONEMeta } from "/codebuild/output/src2543735077/src/nuxt-srovnejto/.srovnejto/telco/pages/packages/inquiry?macro=true";
import { default as thank_45youHaXIwsMuEaMeta } from "/codebuild/output/src2543735077/src/nuxt-srovnejto/.srovnejto/telco/pages/packages/thank-you?macro=true";
import { default as calculationLREJxkNOymMeta } from "/codebuild/output/src2543735077/src/nuxt-srovnejto/.srovnejto/energo/pages/calculation?macro=true";
import { default as offer_45list4rgYMreU0XMeta } from "/codebuild/output/src2543735077/src/nuxt-srovnejto/.srovnejto/energo/pages/offer-list?macro=true";
import { default as thank_45yousorfw2KMnVMeta } from "/codebuild/output/src2543735077/src/nuxt-srovnejto/.srovnejto/energo/pages/thank-you?macro=true";
import { default as inquiry_45onlinewcGG8Yl1KMMeta } from "/codebuild/output/src2543735077/src/nuxt-srovnejto/.srovnejto/energo/pages/inquiry-online?macro=true";
import { default as detailPl3dqmnNE8Meta } from "/codebuild/output/src2543735077/src/nuxt-srovnejto/.srovnejto/energo/pages/detail?macro=true";
import { default as inquiry_45phoneRiKA6CEjJWMeta } from "/codebuild/output/src2543735077/src/nuxt-srovnejto/.srovnejto/energo/pages/inquiry-phone?macro=true";
import { default as inquiry_45custom_45offerlIzb5fl5aSMeta } from "/codebuild/output/src2543735077/src/nuxt-srovnejto/.srovnejto/energo/pages/inquiry-custom-offer?macro=true";
export default [
  {
    name: "nepodcento-slug",
    path: "/nepodcento/:slug()",
    component: () => import("/codebuild/output/src2543735077/src/nuxt-srovnejto/pages/nepodcento/[slug].vue")
  },
  {
    name: "nepodcento",
    path: "/nepodcento",
    component: () => import("/codebuild/output/src2543735077/src/nuxt-srovnejto/pages/nepodcento/index.vue")
  },
  {
    name: "volne-pozice-slug",
    path: "/volne-pozice/:slug()",
    component: () => import("/codebuild/output/src2543735077/src/nuxt-srovnejto/pages/volne-pozice/[slug].vue")
  },
  {
    name: pageoURvjj3AvnMeta?.name,
    path: "/:all(.*)*",
    component: () => import("/codebuild/output/src2543735077/src/nuxt-srovnejto/.srovnejto/storyblok/pages/storyblok/page")
  },
  {
    name: headers_45testvokeNXNeVqMeta?.name,
    path: "/headers-test",
    component: () => import("/codebuild/output/src2543735077/src/nuxt-srovnejto/.srovnejto/storyblok/pages/storyblok/headers-test")
  },
  {
    name: homepage4eOMn8H449Meta?.name,
    path: "/blog",
    component: () => import("/codebuild/output/src2543735077/src/nuxt-srovnejto/.srovnejto/storyblok/pages/blog/homepage")
  },
  {
    name: articlezXVKd5dO8EMeta?.name,
    path: "/blog/:article(.*)*",
    component: () => import("/codebuild/output/src2543735077/src/nuxt-srovnejto/.srovnejto/storyblok/pages/blog/article")
  },
  {
    name: document_45patternsFCqj4Xa3v5Meta?.name,
    path: "/blog/vzory-dokumentu",
    component: () => import("/codebuild/output/src2543735077/src/nuxt-srovnejto/.srovnejto/storyblok/pages/blog/document-patterns")
  },
  {
    name: tag98NGVbty66Meta?.name,
    path: "/blog/tag/:slug(.*)*",
    component: () => import("/codebuild/output/src2543735077/src/nuxt-srovnejto/.srovnejto/storyblok/pages/blog/tag")
  },
  {
    name: autorOzgQE1bzMKMeta?.name,
    path: "/blog/autor/:slug(.*)*",
    component: () => import("/codebuild/output/src2543735077/src/nuxt-srovnejto/.srovnejto/storyblok/pages/blog/autor")
  },
  {
    name: categoryyTdaG31isMMeta?.name,
    path: "/blog/:category(pojisteni|finance|domacnost)",
    component: () => import("/codebuild/output/src2543735077/src/nuxt-srovnejto/.srovnejto/storyblok/pages/blog/category")
  },
  {
    name: sectionMJPP5NBDrBMeta?.name,
    path: "/blog/:category(pojisteni|finance|domacnost)/:section(auto|cestovani|zivot|dum-a-domacnost|osobni-finance|pujcky-a-uvery|hypoteky|energie|tarify)",
    component: () => import("/codebuild/output/src2543735077/src/nuxt-srovnejto/.srovnejto/storyblok/pages/blog/section")
  },
  {
    name: all_45articles76OGgVzMztMeta?.name,
    path: "/blog/all-articles",
    component: () => import("/codebuild/output/src2543735077/src/nuxt-srovnejto/.srovnejto/storyblok/pages/blog/all-articles")
  },
  {
    name: pageoURvjj3AvnMeta?.name,
    path: "/slovnik-pojmu",
    component: () => import("/codebuild/output/src2543735077/src/nuxt-srovnejto/.srovnejto/storyblok/pages/storyblok/page")
  },
  {
    name: categoryvtbFvDmYZtMeta?.name,
    path: "/slovnik-pojmu/:category(pojisteni|pujcky-a-uvery|mobilni-tarify-a-internet|energie)",
    component: () => import("/codebuild/output/src2543735077/src/nuxt-srovnejto/.srovnejto/storyblok/pages/glossary-of-terms/category")
  },
  {
    name: articleJSpzodw6xfMeta?.name,
    path: "/slovnik-pojmu/:category(pojisteni|pujcky-a-uvery|mobilni-tarify-a-internet|energie)/:id(.*)*",
    component: () => import("/codebuild/output/src2543735077/src/nuxt-srovnejto/.srovnejto/storyblok/pages/glossary-of-terms/article")
  },
  {
    name: sectionV7IWqIZxQyMeta?.name,
    path: "/radce/",
    component: () => import("/codebuild/output/src2543735077/src/nuxt-srovnejto/.srovnejto/storyblok/pages/adviser/section")
  },
  {
    name: sectionV7IWqIZxQyMeta?.name,
    path: "/radce/:slug(.*)",
    component: () => import("/codebuild/output/src2543735077/src/nuxt-srovnejto/.srovnejto/storyblok/pages/adviser/section")
  },
  {
    name: complaintqZp9aBiZZwMeta?.name,
    path: "/reklamace",
    component: () => import("/codebuild/output/src2543735077/src/nuxt-srovnejto/.srovnejto/storyblok/pages/forms/complaint")
  },
  {
    name: price_45guarantee2oWX8rgzBWMeta?.name,
    path: "/garance-nejnizsi-ceny",
    component: () => import("/codebuild/output/src2543735077/src/nuxt-srovnejto/.srovnejto/storyblok/pages/forms/price-guarantee")
  },
  {
    name: contactfogqljlmgvMeta?.name,
    path: "/kontakt",
    component: () => import("/codebuild/output/src2543735077/src/nuxt-srovnejto/.srovnejto/storyblok/pages/forms/contact")
  },
  {
    name: car_45insurance_45terminationmWt6lXuZIKMeta?.name,
    path: "/jak-zmenit-pojistovnu",
    component: () => import("/codebuild/output/src2543735077/src/nuxt-srovnejto/.srovnejto/storyblok/pages/forms/car-insurance-termination")
  },
  {
    name: mediaMZJwRAW6tUMeta?.name,
    path: "/pro-media",
    component: () => import("/codebuild/output/src2543735077/src/nuxt-srovnejto/.srovnejto/storyblok/pages/press/media")
  },
  {
    name: pressZm39Q9glDBMeta?.name,
    path: "/press",
    component: () => import("/codebuild/output/src2543735077/src/nuxt-srovnejto/.srovnejto/storyblok/pages/press/press")
  },
  {
    name: slugVNu5yjJh0BMeta?.name,
    path: "/press/:slug",
    component: () => import("/codebuild/output/src2543735077/src/nuxt-srovnejto/.srovnejto/storyblok/pages/press/slug")
  },
  {
    name: zadostgsAJfsnOuAMeta?.name,
    path: "/pujcky-a-uvery/:provider(zaplo-online-pujcka|zaplo-na-splatky-online-pujcka|home-credit-online-pujcka|csob-online-pujcka|komercni-banka-pujcka|ceska-sporitelna|kamali)/zadost",
    component: () => import("/codebuild/output/src2543735077/src/nuxt-srovnejto/.srovnejto/loans/pages/loans/uniform/zadost")
  },
  {
    name: thankILCoC9jpGWMeta?.name,
    path: "/pujcky-a-uvery/:provider(zaplo-online-pujcka|zaplo-na-splatky-online-pujcka|home-credit-online-pujcka|csob-online-pujcka|komercni-banka-pujcka|ceska-sporitelna|kamali)/:thank(dekujeme|zamitnuto-partner|zamitnuto)",
    component: () => import("/codebuild/output/src2543735077/src/nuxt-srovnejto/.srovnejto/loans/pages/loans/uniform/thank")
  },
  {
    name: srovnaniV4lUYULsxBMeta?.name,
    path: "/pujcky-a-uvery/pujcka-na-miru/srovnani",
    component: () => import("/codebuild/output/src2543735077/src/nuxt-srovnejto/.srovnejto/loans/pages/loans/pujcka-na-miru/srovnani")
  },
  {
    name: calculationyqpkwxj0UoMeta?.name,
    path: "/internet/kalkulace",
    component: () => import("/codebuild/output/src2543735077/src/nuxt-srovnejto/.srovnejto/telco/pages/internet/calculation")
  },
  {
    name: thank_45you4aN2CnqAatMeta?.name,
    path: "/internet/prehled-vaseho-pozadavku",
    component: () => import("/codebuild/output/src2543735077/src/nuxt-srovnejto/.srovnejto/telco/pages/internet/thank-you")
  },
  {
    name: detailWYAjS541OmMeta?.name,
    path: "/internet/srovnani-nabidek/:leadId?/detail",
    component: () => import("/codebuild/output/src2543735077/src/nuxt-srovnejto/.srovnejto/telco/pages/internet/detail")
  },
  {
    name: inquiry9988CGsgIDMeta?.name,
    path: "/internet/sjednani-nabidky/:leadId?",
    component: () => import("/codebuild/output/src2543735077/src/nuxt-srovnejto/.srovnejto/telco/pages/internet/inquiry")
  },
  {
    name: offer_45listZD769t2j70Meta?.name,
    path: "/internet/srovnani-nabidek/:leadId?",
    component: () => import("/codebuild/output/src2543735077/src/nuxt-srovnejto/.srovnejto/telco/pages/internet/offer-list")
  },
  {
    name: calculationwt5eV9dsJTMeta?.name,
    path: "/mobilni-tarify/kalkulace",
    component: () => import("/codebuild/output/src2543735077/src/nuxt-srovnejto/.srovnejto/telco/pages/mobile/calculation")
  },
  {
    name: thank_45youqslCMtMBVhMeta?.name,
    path: "/mobilni-tarify/prehled-vaseho-pozadavku",
    component: () => import("/codebuild/output/src2543735077/src/nuxt-srovnejto/.srovnejto/telco/pages/mobile/thank-you")
  },
  {
    name: inquiry8Hsy8u6AvBMeta?.name,
    path: "/mobilni-tarify/sjednani-nabidky/:leadId?",
    component: () => import("/codebuild/output/src2543735077/src/nuxt-srovnejto/.srovnejto/telco/pages/mobile/inquiry")
  },
  {
    name: offer_45listAOX6BHMCEvMeta?.name,
    path: "/mobilni-tarify/srovnani-nabidek/:leadId?",
    component: () => import("/codebuild/output/src2543735077/src/nuxt-srovnejto/.srovnejto/telco/pages/mobile/offer-list")
  },
  {
    name: detailmWcgGuLqJnMeta?.name,
    path: "/mobilni-tarify/srovnani-nabidek/:leadId?/detail",
    component: () => import("/codebuild/output/src2543735077/src/nuxt-srovnejto/.srovnejto/telco/pages/mobile/detail")
  },
  {
    name: offerfx7r4Xu8cxMeta?.name,
    path: "/balicky-sluzeb/priklad-nabidky",
    component: () => import("/codebuild/output/src2543735077/src/nuxt-srovnejto/.srovnejto/telco/pages/packages/offer")
  },
  {
    name: inquiryFFip9VqONEMeta?.name,
    path: "/balicky-sluzeb/sjednani-nabidky",
    component: () => import("/codebuild/output/src2543735077/src/nuxt-srovnejto/.srovnejto/telco/pages/packages/inquiry")
  },
  {
    name: thank_45youHaXIwsMuEaMeta?.name,
    path: "/balicky-sluzeb/potvrzeni-objednavky",
    component: () => import("/codebuild/output/src2543735077/src/nuxt-srovnejto/.srovnejto/telco/pages/packages/thank-you")
  },
  {
    name: calculationLREJxkNOymMeta?.name,
    path: "/energie/kalkulace-:vertical(elektrina|plyn)/:leadId?",
    component: () => import("/codebuild/output/src2543735077/src/nuxt-srovnejto/.srovnejto/energo/pages/calculation")
  },
  {
    name: offer_45list4rgYMreU0XMeta?.name,
    path: "/energie/srovnani-nabidek/:vertical(plyn|elektrina)/:leadId?",
    component: () => import("/codebuild/output/src2543735077/src/nuxt-srovnejto/.srovnejto/energo/pages/offer-list")
  },
  {
    name: thank_45yousorfw2KMnVMeta?.name,
    path: "/energie/prehled-vaseho-pozadavku/:leadId?",
    component: () => import("/codebuild/output/src2543735077/src/nuxt-srovnejto/.srovnejto/energo/pages/thank-you")
  },
  {
    name: inquiry_45onlinewcGG8Yl1KMMeta?.name,
    path: "/energie/sjednani-online/:vertical(elektrina|plyn)/:leadId?",
    component: () => import("/codebuild/output/src2543735077/src/nuxt-srovnejto/.srovnejto/energo/pages/inquiry-online")
  },
  {
    name: detailPl3dqmnNE8Meta?.name,
    path: "/energie/srovnani-nabidek/:vertical(plyn|elektrina)/:leadId/detail/:tariffId",
    component: () => import("/codebuild/output/src2543735077/src/nuxt-srovnejto/.srovnejto/energo/pages/detail")
  },
  {
    name: inquiry_45phoneRiKA6CEjJWMeta?.name,
    path: "/energie/sjednani-po-telefonu/:vertical(plyn|elektrina)/:leadId?",
    component: () => import("/codebuild/output/src2543735077/src/nuxt-srovnejto/.srovnejto/energo/pages/inquiry-phone")
  },
  {
    name: inquiry_45custom_45offerlIzb5fl5aSMeta?.name,
    path: "/energie/nabidka-na-miru",
    component: () => import("/codebuild/output/src2543735077/src/nuxt-srovnejto/.srovnejto/energo/pages/inquiry-custom-offer")
  }
]